import numberFormatter from '../../utils/formatNumber';
import { Box, Typography } from '@mui/material';
import {
  MODEL_SCORING_METRIC_ECPM_LIFT,
  MODEL_SCORING_METRIC_HIGH_VALUE_USERS,
  MODEL_SCORING_METRIC_TOTAL_AUDIENCE,
} from '../../content';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import type { ValueClassCompositionPreview } from '../../types/modelScoring';

const TEXT_MUTED = '#685d6f';
const TEXT_PRIMARY = '#1a1a1a';
const ECPM_GREEN = '#2e7d32';
const TOTAL_BLACK = '#000000';
const METRICS_DIVIDER = '#e8e4ef';
const METRICS_BORDER = '#d3d3d3';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(2),
      marginTop: theme.spacing(2),
      paddingTop: theme.spacing(2),
      borderTop: `1px solid ${METRICS_DIVIDER}`,
      textAlign: 'center',
      [theme.breakpoints.up('md')]: {
        flexDirection: 'row',
      },
    },
    card: {
      flex: 1,
      minWidth: 0,
      border: `1px solid ${METRICS_BORDER}`,
      borderRadius: 10,
      padding: 5,
    },
    metricLabel: {
      '&&': {
        fontFamily: 'Calibre-Regular,sans-serif',
        fontSize: 14,
        color: TEXT_MUTED,
      },
    },
    metricLabelEcpm: {
      '&&': {
        fontFamily: 'Calibre-Regular,sans-serif',
        fontSize: 14,
        color: ECPM_GREEN,
      },
    },
    metricValue: {
      '&&': {
        fontFamily: 'Calibre-Semibold,sans-serif',
        fontWeight: 600,
        fontSize: 20,
        lineHeight: '28px',
        color: TEXT_PRIMARY,
      },
    },
    metricValueEcpmLift: {
      '&&': {
        fontFamily: 'Calibre-Semibold,sans-serif',
        fontWeight: 600,
        fontSize: 20,
        lineHeight: '28px',
        color: ECPM_GREEN,
      },
    },
    metricValueTotalAudience: {
      '&&': {
        fontFamily: 'Calibre-Semibold,sans-serif',
        fontWeight: 600,
        fontSize: 20,
        lineHeight: '28px',
        color: TOTAL_BLACK,
      },
    },
  })
);

export interface ModelScoringSummaryMetricsProps {
  data: ValueClassCompositionPreview;
}

const ModelScoringSummaryMetrics = ({
  data,
}: ModelScoringSummaryMetricsProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.card}>
        <Typography className={classes.metricLabel}>
          {MODEL_SCORING_METRIC_HIGH_VALUE_USERS}
        </Typography>
        <Typography className={classes.metricValue}>
          ~{numberFormatter(data.high_count, 1)}
        </Typography>
      </Box>
      <Box className={classes.card}>
        <Typography className={classes.metricLabelEcpm}>
          {MODEL_SCORING_METRIC_ECPM_LIFT}
        </Typography>
        <Typography className={classes.metricValueEcpmLift}>
          {data.est_ecpm_lift_pct == null
            ? '—'
            : `${data.est_ecpm_lift_pct > 0 ? '+' : ''}${
                data.est_ecpm_lift_pct
              }%`}
        </Typography>
      </Box>
      <Box className={classes.card}>
        <Typography className={classes.metricLabel}>
          {MODEL_SCORING_METRIC_TOTAL_AUDIENCE}
        </Typography>
        <Typography className={classes.metricValueTotalAudience}>
          ~{numberFormatter(data.total_count, 1)}
        </Typography>
      </Box>
    </Box>
  );
};

export default ModelScoringSummaryMetrics;
